import type { Authentication } from "@/lib/authentication"

const supportedProviderIds: Record<Authentication.ProviderId, true> = {
  "google.com": true,
  password: true,
}

export const hasSupportedProviderId = (
  subject: unknown
): subject is { providerId: Authentication.ProviderId } => {
  if (subject && typeof subject === `object`) {
    const { providerId } = subject as {
      providerId: Authentication.ProviderId
    }

    return supportedProviderIds[providerId]
  }

  return false
}
